import { useQuery } from '@tanstack/react-query';

import { type RoomDetails } from '~entities/rooms/modal/room';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const getAllRoomsAPI = async () => {
  const response = await baseAPI.get<Array<RoomDetails>>(`/custom-form/room`);
  return response.data;
};

export const useGetAllRooms = () => {
  return useQuery({
    queryKey: [KEYS.ROOMS],
    queryFn: () => getAllRoomsAPI(),
  });
};
